import { render, staticRenderFns } from "./ModalUploadPlatformPushCertificate.vue?vue&type=template&id=54524cfa&"
import script from "./ModalUploadPlatformPushCertificate.vue?vue&type=script&lang=js&"
export * from "./ModalUploadPlatformPushCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports